<footer class="footer-component">
  <p class="footer-content pt-2">
    <small class="text-muted">
      Copyright © 2023 Axivise Technologies Pvt. Ltd. All rights reserved.
    </small>

  </p>
</footer>